import { configureStore, Tuple } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage"; // Defaults to localStorage for web
import { persistReducer, persistStore, createTransform } from "redux-persist";
import authReducer from "../slices/authSlice";
import { combineReducers } from "redux";
import CryptoJS from "crypto-js";

const encryptionKey = process.env.REACT_APP_ENCRYPTION_KEY;

// Combine reducers (if multiple reducers exist)
const rootReducer = combineReducers({
  auth: authReducer,
});

const encryptTransform = createTransform(
  (inboundState, key) => {
    if (!inboundState) return inboundState;
    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(inboundState),
      encryptionKey
    ).toString();
    return encrypted;
  },
  (outboundState: any, key) => {
    if (!outboundState) return outboundState;
    const decrypted = CryptoJS.AES.decrypt(outboundState, encryptionKey);
    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
  }
);

// Persist Configuration
const persistConfig: any = {
  key: "root", // The key to store data under
  storage, // Uses localStorage by default
  transforms: [encryptTransform],
};

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store with persisted reducer
export const store = configureStore({
  reducer: persistedReducer,
  middleware: () => new Tuple(),
  devTools: process.env.REACT_APP_NODE_ENV === "dev",
});

// Create persistor
export const persistor = persistStore(store);

// Define RootState and AppDispatch for type safety
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// // third-party
// import { Tuple, configureStore } from '@reduxjs/toolkit';
// import { persistStore, persistReducer, createTransform } from 'redux-persist';
// import storage from 'redux-persist/lib/storage';
// import CryptoJS from 'crypto-js';
// import { combineReducers } from "redux";

// import authReducer from '../slices/authSlice';

// const ENCRYPTION_KEY = 'emergency-services#$h@7665#$';

// // Combine reducers (if multiple reducers exist)
// const rootReducer = combineReducers({
//   auth: authReducer,
// });

// const encryptTransform = createTransform(
//   (inboundState, key) => {
//     if (!inboundState) return inboundState;
//     const encrypted = CryptoJS.AES.encrypt(
//       JSON.stringify(inboundState),
//       ENCRYPTION_KEY
//     ).toString();
//     return encrypted;
//   },
//   (outboundState:any, key) => {
//     if (!outboundState) return outboundState;
//     const decrypted = CryptoJS.AES.decrypt(outboundState, ENCRYPTION_KEY);
//     return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
//   }
// );

// const persistConfig:any = {
//   key: 'root',
//   storage,
//   transforms: [encryptTransform],
// };

// const persistedReducer = persistReducer(persistConfig, rootReducer);

// const store = configureStore({
//   reducer: persistedReducer,
//   middleware: () => new Tuple()
// });

// const persistor = persistStore(store);

// export { store, persistor };
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;
